import PagePlaylist from "../../page-playlist/PagePlaylist"
const PlayList = () => {
    return (
        <PagePlaylist />
    );
}

export default PlayList;